"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyToString = transformCurrencyToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformCurrencyToString(currency) {
    switch (currency) {
        case legacy_enums_1.Currency.Euro:
            return "€";
        case legacy_enums_1.Currency.CanadianDollar:
        case legacy_enums_1.Currency.AustralianDollar:
        case legacy_enums_1.Currency.NewZealandDollar:
        case legacy_enums_1.Currency.Dollar:
            return "$";
        case legacy_enums_1.Currency.BritishPound:
            return "£";
        default:
            return "$";
    }
}
//# sourceMappingURL=transformCurrencyToString.js.map